const footer = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Footer",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Content",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Page Name",
                    placeholder: "Enter Page Name",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                  group: {
                    type: "footerGroupSelect",
                    label: "Group",
                    placeholder: "Select Group",
                    load_url: "",
                    required: false,
                    info: false,
                    character_count: 0,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                  // "subgroup": {
                  //     "type": 'subgroupSelect',
                  //     "label": 'Sub-Group',
                  //     "placeholder": 'Select Sub-Group',
                  //     "load_url": '',
                  //     "required": false,
                  //     "info": false,
                  //     "character_count": 0,
                  //     "disabled": false,
                  //     "class": '',
                  //     "size": "6",
                  //     "style": ""
                  // },
                },
                additionalProps: {
                  // "role": '',
                  group: "",
                  link_type: "External Link",
                  link_url: "",
                  // "subgroup": '',
                  // "locations": '',
                  // "qualifications": '',
                  // "availability": {
                  //     'locations':  []
                  // },
                  // "gender": {
                  //     'name':  'Male'
                  // },
                },
              },
            },
            children: [
              {
                type: "footerTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Labels",
                  type: "list",
                  variant: "filtered",
                  filter: "labels",
                  filterOn: "group",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Label",
                      placeholder: "Enter Member Name",
                      required: false,
                      info: false,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    link_type: {
                      type: "select",
                      label: "Link Type",
                      placeholder: "Select Link Type",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: ["External Link", "Internal Link"],
                    },
                    link_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Enter Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    // "role": {
                    //     "type": 'text',
                    //     "label": 'Role',
                    //     "placeholder": 'Enter Role',
                    //     "required": true,
                    //     "info": true,
                    //     "character_count": 250,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "qualifications": {
                    //     "type": 'text',
                    //     "label": 'Qualifications',
                    //     "placeholder": 'Enter Qualifications',
                    //     "required": true,
                    //     "info": true,
                    //     "character_count": 250,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "locations": {
                    //     "type": 'locationMultiSelect',
                    //     "label": 'Location(s)',
                    //     "inside": ['additionalProp1', 'availability', 'locations'],
                    //     "placeholder": 'Select Location',
                    //     "load_url": '',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "gender": {
                    //     "type": 'radioObject',
                    //     "label": 'Gender',
                    //     "placeholder": 'Select Gender',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": "",
                    //     "options": [
                    //         {
                    //           "name": 'Male',
                    //         },
                    //         {
                    //           "name": 'Female',
                    //         }
                    //       ]
                    // },
                    // "group": {
                    //     "type": 'groupSelect',
                    //     "label": 'Group',
                    //     "placeholder": 'Select Group',
                    //     "inside": ['additionalProp1', 'group'],
                    //     "load_url": '',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "subgroup": {
                    //     "type": 'subgroupSelect',
                    //     "label": 'Sub-Group',
                    //     "placeholder": 'Select Sub-Group',
                    //     "inside": ['additionalProp1', 'subgroup'],
                    //     "load_url": '',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "group": {
                    //     "type": 'select',
                    //     "label": 'Group',
                    //     "placeholder": 'Select Group',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": "",
                    //     "options": []
                    // },
                    // "subgroup": {
                    //     "type": 'select',
                    //     "label": 'Sub-Group',
                    //     "placeholder": 'Select Sub-Group',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": "",
                    //     "options": []
                    // },
                    // "description": {
                    //     "type": 'ckeditor',
                    //     "label": 'Description',
                    //     "placeholder": 'Enter Description',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 2000,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    get_the_nhs_app: {
                      type: "toggle",
                      label: "Get the NHS App",
                      placeholder: "Select",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr0: {
                      type: "hr",
                      size: "12",
                    },
                    ccq_id: {
                      type: "text",
                      label: "CQC ID",
                      placeholder: "Enter CQC ID",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                    dementia_friendly_status: {
                      type: "toggle",
                      label: "Dementia Friendly",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image1: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "dementia-friendly.png",
                      displayOn: "dementia_friendly_status",
                      displayOnValue: "true",
                    },
                    dementia_friendly_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "dementia_friendly_status",
                      displayOnValue: "true",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    armed_forces_veteran_status: {
                      type: "toggle",
                      label: "Armed Forced Veteran Friendly",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image2: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "veteran-friendly.png",
                      displayOn: "armed_forces_veteran_status",
                      displayOnValue: "true",
                    },
                    armed_forces_veteran_url: {
                      type: "text",
                      label: "Link",
                      displayOn: "armed_forces_veteran_status",
                      displayOnValue: "true",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    learning_disability_friendly_status: {
                      type: "toggle",
                      label: "Learning Disability Friendly",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image3: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "learning-disability-friendly.png",
                      displayOn: "learning_disability_friendly_status",
                      displayOnValue: "true",
                    },
                    learning_disability_friendly_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "learning_disability_friendly_status",
                      displayOnValue: "true",
                    },
                    hr3a: {
                      type: "hr",
                      size: "12",
                    },
                    parkrun_status: {
                      type: "toggle",
                      label: "Parkrun Practice",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image4a: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "parkrun.png",
                      displayOn: "parkrun_status",
                      displayOnValue: "true",
                    },
                    parkrun_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "parkrun_status",
                      displayOnValue: "true",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    yellow_fever_zone_status: {
                      type: "toggle",
                      label: "Yellow Fever Zone",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image4: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "yellowfewerzone.png",
                      displayOn: "yellow_fever_zone_status",
                      displayOnValue: "true",
                    },
                    yellow_fever_zone_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "yellow_fever_zone_status",
                      displayOnValue: "true",
                    },
                    hr5: {
                      type: "hr",
                      size: "12",
                    },
                    safe_surgery_status: {
                      type: "toggle",
                      label: "Safe Surgery",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image5: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "safesurgery.png",
                      displayOn: "safe_surgery_status",
                      displayOnValue: "true",
                    },
                    safe_surgery_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "safe_surgery_status",
                      displayOnValue: "true",
                    },
                    hr6: {
                      type: "hr",
                      size: "12",
                    },
                    sustainable_general_practice_status: {
                      type: "toggle",
                      label: "Sustainable General Practice",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image6: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "sustainable_general_practice.png",
                      displayOn: "sustainable_general_practice_status",
                      displayOnValue: "true",
                    },
                    sustainable_general_practice_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "sustainable_general_practice_status",
                      displayOnValue: "true",
                    },
                    hr7: {
                      type: "hr",
                      size: "12",
                    },
                    nhs_status: {
                      type: "toggle",
                      label: "NHS",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image7: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "nhs.png",
                      displayOn: "nhs_status",
                      displayOnValue: "true",
                    },
                    nhs_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "nhs_status",
                      displayOnValue: "true",
                    },
                    hr8: {
                      type: "hr",
                      size: "12",
                    },
                    lgbt_foundation_status: {
                      type: "toggle",
                      label: " LGBT Foundation",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image8: {
                      label: "Preview ",
                      type: "footerImage",
                      size: "12",
                      source: "LGBT.png",
                      displayOn: "lgbt_foundation_status",
                      displayOnValue: "true",
                    },
                    lgbt_foundation_url: {
                      type: "text",
                      label: "Link ",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "lgbt_foundation_status",
                      displayOnValue: "true",
                    },
                    hr9: {
                      type: "hr",
                      size: "12",
                    },
                    safeplace_status: {
                      type: "toggle",
                      label: " Safe Places",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image9: {
                      label: "Preview ",
                      type: "footerImage",
                      size: "12",
                      source: "safeplace.png",
                      displayOn: "safeplace_status",
                      displayOnValue: "true",
                    },
                    safeplace_url: {
                      type: "text",
                      label: "Link ",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "safeplace_status",
                      displayOnValue: "true",
                    },
                    hr10: {
                      type: "hr",
                      size: "12",
                    },
                    greenimpactpioneer_status: {
                      type: "toggle",
                      label: " Green Impact Pioneer",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image10: {
                      label: "Preview ",
                      type: "footerImage",
                      size: "12",
                      source: "greenimpactpioneer.png",
                      displayOn: "greenimpactpioneer_status",
                      displayOnValue: "true",
                    },
                    greenimpactpioneer_url: {
                      type: "text",
                      label: "Link ",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "greenimpactpioneer_status",
                      displayOnValue: "true",
                    },
                    hr11: {
                      type: "hr",
                      size: "12",
                    },
                    irisi_interventions_status: {
                      type: "toggle",
                      label: "IRISi Interventions",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image11: {
                      label: "Preview ",
                      type: "footerImage",
                      size: "12",
                      source: "IRISi.png",
                      displayOn: "irisi_interventions_status",
                      displayOnValue: "true",
                    },
                    irisi_interventions_url: {
                      type: "text",
                      label: "Link ",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "irisi_interventions_status",
                      displayOnValue: "true",
                    },
                    hr13: {
                      type: "hr",
                      size: "12",
                    },
                    gambling_harms_status: {
                      type: "toggle",
                      label: "Gambling Harms",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image12: {
                      label: "Preview ",
                      type: "footerImage",
                      size: "12",
                      source: "gambling.png",
                      displayOn: "gambling_harms_status",
                      displayOnValue: "true",
                    },
                    gambling_harms_url: {
                      type: "text",
                      label: "Link ",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "gambling_harms_status",
                      displayOnValue: "true",
                    },
                    hr12: {
                      type: "hr",
                      size: "12",
                    },
                    nihr_status: {
                      type: "toggle",
                      label: "NIHR",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image13: {
                      label: "Preview ",
                      type: "footerImage",
                      size: "12",
                      source: "NIHRlogo.png",
                      displayOn: "nihr_status",
                      displayOnValue: "true",
                    },
                    nihr_url: {
                      type: "text",
                      label: "Link ",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "nihr_status",
                      displayOnValue: "true",
                    },
                    hr14: {
                      type: "hr",
                      size: "12",
                    },
                    bronze_award_2025_status: {
                      type: "toggle",
                      label: "Bronze Award 2025",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image_bronze_2025: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "Bronze Award 2025.png",
                      displayOn: "bronze_award_2025_status",
                      displayOnValue: "true",
                    },
                    bronze_award_2025_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "bronze_award_2025_status",
                      displayOnValue: "true",
                    },
                    hr15: {
                      type: "hr",
                      size: "12",
                    },
                    health_wealth_status: {
                      type: "toggle",
                      label: "Health Wealth",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image_health_wealth: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "health_wealth.png",
                      displayOn: "health_wealth_status",
                      displayOnValue: "true",
                    },
                    health_wealth_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "health_wealth_status",
                      displayOnValue: "true",
                    },
                    hr_health_wealth: {
                      type: "hr",
                      size: "12",
                    },
                    neurodiversity_status: {
                      type: "toggle",
                      label: "Neurodiversity",
                      placeholder: "Select Featured",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    image_neurodiversity: {
                      label: "Preview",
                      type: "footerImage",
                      size: "12",
                      source: "neurodiversity.svg",
                      displayOn: "neurodiversity_status",
                      displayOnValue: "true",
                    },
                    neurodiversity_url: {
                      type: "text",
                      label: "Link",
                      placeholder: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      displayOn: "neurodiversity_status",
                      displayOnValue: "true",
                    },
                    hr_neurodiversity: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { footer };
